export class MasterItem
{
    public id: string;
    public value: string;
}